import { render, staticRenderFns } from "./CreateLocationModal.vue?vue&type=template&id=408f0285&scoped=true&"
import script from "./CreateLocationModal.vue?vue&type=script&lang=js&"
export * from "./CreateLocationModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateLocationModal.vue?vue&type=style&index=0&id=408f0285&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f0285",
  null
  
)

export default component.exports